import { render, staticRenderFns } from "./distributor_goods.vue?vue&type=template&id=2a0a4853&scoped=true&"
import script from "./distributor_goods.vue?vue&type=script&lang=js&"
export * from "./distributor_goods.vue?vue&type=script&lang=js&"
import style0 from "./distributor_goods.vue?vue&type=style&index=0&lang=css&"
import style1 from "./distributor_goods.vue?vue&type=style&index=1&id=2a0a4853&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a4853",
  null
  
)

export default component.exports